export default __webpack_public_path__ + "static/rings-41d5027a46c4c21afb3979f9200d36f4.png";